import type { ReactNode } from 'react';
import classes from './Panel.module.css';

export interface PanelProps {
  title?: string;
  /** Başlığın solundaki ikon (≈ 18 px); ekran okuyucudan gizlenir. */
  icon?: ReactNode;
  /** Başlığın sağı: "View all" bağlantısı, rozet. */
  extra?: ReactNode;
  /** Başlığın altında kenardan kenara ince çizgi. */
  divider?: boolean;
  /**
   * Gövdede kenar boşluğu yok (tablo kartı). Başlıklı kartta başlık altındaki boşluk korunur;
   * başlıksız kartta içerik üst kenara yapışmasın diye yalnız üstte 12 px kalır.
   */
  flush?: boolean;
  className?: string | undefined;
  children: ReactNode;
  /** Bölge adı ekran okuyucuya: başlık varsa o. */
  'aria-label'?: string;
}

/**
 * BGM kartı: beyaz zemin, ince kenarlık, 8 px köşe; 16 px yarı kalın başlık (personel-*.jpeg
 * "Crew List", "MLC Compliance"; referansta ≈ 13 px × 1,25; M6f G1-06).
 */
export function Panel({
  title,
  icon,
  extra,
  divider = false,
  flush = false,
  className,
  children,
  ...rest
}: PanelProps) {
  const headed = Boolean(title || extra);
  return (
    <section
      className={[classes.panel, className].filter(Boolean).join(' ')}
      data-flush={flush || undefined}
      data-divider={(headed && divider) || undefined}
      data-headed={headed || undefined}
      aria-label={rest['aria-label'] ?? title}
    >
      {headed ? (
        <div className={classes.head}>
          {title ? (
            <div className={classes.heading}>
              {icon ? (
                <span className={classes.icon} aria-hidden>
                  {icon}
                </span>
              ) : null}
              <h2 className={classes.title}>{title}</h2>
            </div>
          ) : (
            <span />
          )}
          {extra}
        </div>
      ) : null}
      <div className={classes.body}>{children}</div>
    </section>
  );
}
